var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.settings
    ? _c("div", { staticStyle: { "text-align": "left" } }, [
        _c(
          "div",
          {
            staticClass: "glossfields",
            staticStyle: { "text-align": "center" },
          },
          _vm._l(_vm.gloss_fields, function (o, i) {
            return _c("GlossQueryField", {
              key: i,
              attrs: { fieldDescription: o },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-default",
            attrs: { type: "button" },
            on: { click: _vm.resetQuery },
          },
          [_vm._v(_vm._s(_vm.$t("formConcept.glossSearch.reset")))]
        ),
        _vm._v(" "),
        _c("div", [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.showQuery,
                  expression: "showQuery",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.showQuery)
                  ? _vm._i(_vm.showQuery, null) > -1
                  : _vm.showQuery,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.showQuery,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.showQuery = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.showQuery = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.showQuery = $$c
                  }
                },
              },
            }),
            _vm._v(
              " " + _vm._s(_vm.$t("formConcept.glossSearch.showQuery")) + " "
            ),
          ]),
          _vm._v(" "),
          _vm.showQuery
            ? _c(
                "div",
                {
                  staticStyle: {
                    border: "1px solid black",
                    "margin-top": "1em",
                    padding: "4pt",
                  },
                },
                [
                  _vm._v("\n\t\t\tJSON: "),
                  _c("pre", {
                    domProps: { textContent: _vm._s(_vm.query_from_store) },
                  }),
                  _vm._v("\n\t\t\tCQL: "),
                  _c("pre", {
                    domProps: { textContent: _vm._s(_vm.query_cql_from_store) },
                  }),
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("formConcept.glossSearch.settings")) +
                      ": "
                  ),
                  _c("pre", {
                    domProps: { textContent: _vm._s(_vm.settings) },
                  }),
                ]
              )
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }